export default {
  methods: {
    selectProductFirstImageSrc (productImages) {
      if (productImages) {
        let topPriorityImage = {}
        productImages.forEach((currentImage, index) => {
          if (
            index === 0 ||
            topPriorityImage.priority > currentImage.priority
          ) {
            topPriorityImage = currentImage
          }
        })
        return topPriorityImage.file.url
      } else {
        return 'http://placehold.jp/eeeeee/cccccc/200x130.png?text=No%20Image'
      }
    }
  }
}
